import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Envelope } from "react-bootstrap-icons";

import logo from "../assets/img/LogoSvg65.svg";
import linkedInIcon from "../assets/img/nav-icon1.svg";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="footer footer-modern"
      aria-label="Website footer"
    >
      <Container>

        <Row className="footer-modern__main g-5">

          {/* BRAND */}
          <Col xs={12} lg={5}>
            <div className="footer-modern__brand">
              <HashLink
  smooth
  className="footer-modern__logo"
  to="/#home"
  aria-label="Kristal Fotonik home page"
>
  <img
    src={logo}
    alt="Kristal Fotonik"
  />
</HashLink>

              <p>
                Advanced electro-optical imaging technologies, camera systems
                and FPGA-based image processing solutions for demanding
                industrial and space applications.
              </p>
            </div>
          </Col>

          {/* QUICK LINKS */}
          <Col xs={12} sm={6} lg={3}>
            <nav
              className="footer-modern__navigation"
              aria-label="Footer navigation"
            >
              <h2>Explore</h2>

              <ul>
                <li>
                  <HashLink smooth to="/#home">
                    Home
                  </HashLink>
                </li>

                <li>
                  <HashLink smooth to="/#skills">
                    Services
                  </HashLink>
                </li>

                <li>
                  <Link to="/products">
                    Products
                  </Link>
                </li>

                <li>
                  <Link to="/opal">
                    Opal-1920S
                  </Link>
                </li>

                <li>
                  <Link to="/startracker">
                    Star Tracker
                  </Link>
                </li>
              </ul>
            </nav>
          </Col>

          {/* CONTACT */}
          <Col xs={12} sm={6} lg={4}>
            <div className="footer-modern__contact">
              <h2>Contact</h2>

              <a
                className="footer-modern__email"
                href="mailto:info@kristalfotonik.com"
              >
                <Envelope aria-hidden="true" />
                info@kristalfotonik.com
              </a>

              <div className="footer-modern__social">
                <a
                  href="https://www.linkedin.com/company/kristal-fotonik"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Visit Kristal Fotonik on LinkedIn"
                >
                  <img
                    src={linkedInIcon}
                    alt=""
                    aria-hidden="true"
                  />

                  <span>LinkedIn</span>
                </a>
              </div>
            </div>
          </Col>

        </Row>

        {/* BOTTOM BAR */}
        <div className="footer-modern__bottom">
          <p>
            © {currentYear} Kristal Fotonik. All Rights Reserved.
          </p>

          <HashLink smooth to="/#connect">
            Start a Conversation
          </HashLink>
        </div>

      </Container>
    </footer>
  );
};